// extracted by mini-css-extract-plugin
export default {"hero":"NoisyPricePopup_hero__19uid"};